document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement("div");
              html.innerHTML = text;
              const recommendations = html.querySelector(
                "product-recommendations"
              );

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 200px 0px",
        }).observe(this);
      }
    }
    customElements.define("product-recommendations", ProductRecommendations);
  }
});

if (typeof window.vvNextSlide === 'undefined') {
  let currentIndex = 0;

  window.vvNextSlide = function () {
    var slider = document.querySelector(".recommendation-slider");
    var sliderItems = document.querySelectorAll(".slider-item");
    currentIndex = (currentIndex + 1) % sliderItems.length;
    updateSlider();
  };

  window.vvPrevSlide = function () {
    var slider = document.querySelector(".recommendation-slider");
    var sliderItems = document.querySelectorAll(".slider-item");
    currentIndex = (currentIndex - 1 + sliderItems.length) % sliderItems.length;
    updateSlider();
  };

  function updateSlider() {
    var slider = document.querySelector(".recommendation-slider");
    var sliderItems = document.querySelectorAll(".slider-item");
    var translateX = -currentIndex * 100;
    slider.style.transform = `translateX(${translateX}%)`;
  }
}
